export enum FeedbackCategory {
	Chats = 'chats',
	Subscription = 'subscription',
	ImageGeneration = 'image_generation',
	VideoGeneration = 'video_generation',
}
